import React, { useRef, useState } from "react";
import { LineChartHeader } from "./LineChartHeader";
import { LineChartActions } from "./LineChartActions";
import { LineChartCanvas } from "./LineChartCanvas";
import { LineChartModal } from "./LineChartModal";
import { useLineChartExport } from "./hooks/useLineChartExport";
import type { LineChartData } from "@/lib/chat/parseLineChartBlock";

interface LineChartProps {
  data: LineChartData;
}

export const LineChart: React.FC<LineChartProps> = ({ data }) => {
  const exportRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const { exportPNG } = useLineChartExport(exportRef, data.title);

  return (
    <>
      <div className="relative w-full overflow-hidden rounded-xl border border-border/60 bg-card shadow-sm">
        <div ref={exportRef}>
          <LineChartHeader title={data.title} />
          <LineChartCanvas data={data} />
        </div>
        <LineChartActions
          onDownload={exportPNG}
          onExpand={() => setExpanded(true)}
        />
      </div>

      <LineChartModal
        open={expanded}
        onClose={() => setExpanded(false)}
        data={data}
      />
    </>
  );
};
